import {Pipe, PipeTransform} from '@angular/core';
/**
 * Pipe for formatting heating states created by karora on 13/06/17.
 */
@Pipe({name: 'heatingState'})
export class HeatingStatePipe implements PipeTransform {
  transform(value: number): string {
    switch (value) {
      case 0:  return 'Off';
      case 1:  return 'On';
      case 2:  return 'Boost';
      case 3:  return 'On with offset';
      case 4:  return 'Holiday Mode';
    }
    return '' + value;
  }
}
